var _path;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgSearch = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.553 21.671l-4.457-4.457a10.569 10.569 0 002.255-6.538A10.675 10.676 0 1010.675 21.35a10.569 10.569 0 006.54-2.255l4.456 4.457a1.334 1.334 0 00.934.387 1.334 1.334 0 00.948-.387 1.334 1.334 0 000-1.882zm-12.878-2.989a8.007 8.007 0 118.007-8.006 8.007 8.007 0 01-8.007 8.006z"
})));
export default SvgSearch;